import { initialState } from "./initialState";
export default () => ({
  ...initialState
});
